
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCFPEjTqHSjzQRt2RnauXKmjGHzrE-dlDc",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "ai-based-lawyer.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "ai-based-lawyer",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "ai-based-lawyer.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "668743054510",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:668743054510:web:494577066c4fcf30b9693f",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-CBFTGK7ZM5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;